import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DarkThemeService {
  private readonly renderer: Renderer2;

  public darkMode$ = new BehaviorSubject<boolean>(false);

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
   * Toggle dark mode on or off
   * @param isDarkMode - Whether dark mode should be enabled
   */
  public setDarkMode(isDarkMode: boolean): void {
    this.darkMode$.next(isDarkMode);
    this.applyDarkMode(isDarkMode);
  }

  /**
   * Apply dark mode to the application
   * @param isDarkMode - Whether dark mode should be enabled
   */
  private applyDarkMode(isDarkMode: boolean): void {
    const htmlElement = document.documentElement;

    if (isDarkMode) {
      htmlElement.classList.add('modo_oscuro-govco');
    } else {
      htmlElement.classList.remove('modo_oscuro-govco');
    }
  }

  /**
   * Get the current dark mode state
   * @returns The current dark mode state
   */
  public isDarkMode(): boolean {
    return this.darkMode$.value;
  }
}
